module.exports = __webpack_public_path__ + "img/tab-icon-member.ab0875bc.svg";